module.exports = __webpack_public_path__ + "static/img/long_lx_blue.506c4ea3.svg";